// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-card-box .ant-card-body{padding:20px}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/CustomCard.scss"],"names":[],"mappings":"AACI,gCACI,YAAA","sourcesContent":[".custom-card-box{\r\n    .ant-card-body {\r\n        padding: 20px\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
